import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "main" }

import store from "@/store";

import { mobileHeader, footerMenu, fullLoading } from "@/common/components";

const headerHeight = "4rem";
const footerHeight = "4.5rem";

export default /*@__PURE__*/_defineComponent({
  __name: 'default',
  props: {
    menuList: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v4d84c5af": (headerHeight),
  "a148d386": (footerHeight)
}))




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(mobileHeader), { height: headerHeight }),
      _createElementVNode("main", _hoisted_3, [
        _renderSlot(_ctx.$slots, "main")
      ]),
      _createVNode(_unref(footerMenu), {
        "menu-list": __props.menuList,
        height: footerHeight
      }, null, 8, ["menu-list"])
    ]),
    (_unref(store).getters.loading)
      ? (_openBlock(), _createBlock(_unref(fullLoading), { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})